import { DATA_COVERAGE, DATA_SOURCES, isCovered } from '@/config/constants';
import InstagramBreadCrumbs, {
    InstagramIndustriesOnlyBreadCrumbs,
} from './InstagramBreadCrumbs';
import PopularityBreadCrumbs, {
    PopularityIndustriesOnlyBreadCrumbs,
} from './PopularityBreadCrumbs';
import TikTokBreadCrumbs, {
    TikTokIndustriesOnlyBreadCrumbs,
} from './TikTokBreadCrumbs';
import GoogleBreadCrumbs from './GoogleBreadCrumbs';
import PlaceholderBreadCrumbs from './PlaceholderBreadcrumbs';

const DataSourceBreadCrumbs = ({ dataSource, cat1, geo, ...props }) => {
    if (!DATA_SOURCES[dataSource]) throw new Error('Invalid data source');
    const isMarketNotCovered =
        geo && dataSource && !DATA_COVERAGE[geo][dataSource];
    const isNotCovered =
        isMarketNotCovered ||
        (dataSource && cat1 && geo && !isCovered({ dataSource, cat1, geo }));
    if (isNotCovered) return <PlaceholderBreadCrumbs {...props} />;
    if (dataSource === DATA_SOURCES.GOOGLE)
        return <GoogleBreadCrumbs {...props} />;
    if (dataSource === DATA_SOURCES.TIKTOK)
        return <TikTokBreadCrumbs {...props} />;
    if (dataSource === DATA_SOURCES.INSTAGRAM)
        return <InstagramBreadCrumbs {...props} />;
    if (dataSource === DATA_SOURCES.POPULARITY)
        return <PopularityBreadCrumbs {...props} />;
    return <PlaceholderBreadCrumbs {...props} />;
};

export const DataSourceIndustriesOnlyBreadCrumbs = ({
    dataSource,
    cat1,
    geo,
    ...props
}) => {
    if (!DATA_SOURCES[dataSource]) throw new Error('Invalid data source');
    const isMarketNotCovered =
        geo && dataSource && !DATA_COVERAGE[geo][dataSource];
    const isNotCovered =
        isMarketNotCovered ||
        (dataSource && cat1 && geo && !isCovered({ dataSource, cat1, geo }));
    if (isNotCovered) return <PlaceholderBreadCrumbs depth={1} {...props} />;
    if (dataSource === DATA_SOURCES.TIKTOK)
        return <TikTokIndustriesOnlyBreadCrumbs {...props} />;
    if (dataSource === DATA_SOURCES.POPULARITY)
        return <PopularityIndustriesOnlyBreadCrumbs {...props} />;
    if (dataSource === DATA_SOURCES.INSTAGRAM)
        return <InstagramIndustriesOnlyBreadCrumbs {...props} />;
    return <PlaceholderBreadCrumbs depth={1} {...props} />;
};

export default DataSourceBreadCrumbs;
